// extracted by mini-css-extract-plugin
export var root = "MastheadOverlay-module--root--r0_To";
export var box = "MastheadOverlay-module--box--25Lni";
export var image = "MastheadOverlay-module--image--pFewH";
export var vidBox = "MastheadOverlay-module--vidBox--2GEza";